// This file was auto-generated by Fern from our API Definition.
export var CurrentSessionResponse;
(function (CurrentSessionResponse) {
    CurrentSessionResponse.UrlUnavailableReason = {
        AgentReferenceMissing: "agent_reference_missing",
        WorkspaceMissing: "workspace_missing",
        WebUrlUnavailable: "web_url_unavailable",
    };
})(CurrentSessionResponse || (CurrentSessionResponse = {}));
